var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChevronRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 16,
    viewBox: "0 0 8 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.231582 1.65081C-0.114137 1.23148 -0.0674265 0.600182 0.335912 0.240761C0.739251 -0.11866 1.34648 -0.0700989 1.6922 0.349226L8 8L1.6922 15.6508C1.34648 16.0701 0.739251 16.1187 0.335912 15.7592C-0.0674265 15.3998 -0.114137 14.7685 0.231582 14.3492L5.46627 8L0.231582 1.65081Z",
    fill: "#FF552E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronRight);
export default __webpack_public_path__ + "static/media/icon-chevron-right.24593e18eb7d3c31de45f968c81a3863.svg";
export { ForwardRef as ReactComponent };